import type { FC } from 'react';

export const ExpertConnectionTabTitle: FC = () => {
  return <>Connect With an Expert</>;
};
